import { FunctionComponent, Suspense } from 'react';

import { Spinner } from '../common';
import Header from './header/Header';
import styles from './layout.module.scss';

interface Props {
  children: React.ReactNode;
}

const Layout: FunctionComponent<Props> = ({ children }) => {
  return (
    <div className={styles.app}>
      <Header />
      <Suspense fallback={<Spinner />}>
        <main className={styles.main}>{children}</main>
      </Suspense>
    </div>
  );
};

export default Layout;
